import React from 'react';
import styled from '@emotion/styled';
import PageHeader from '../components/PageHeader';

const LegalContainer = styled.div`
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContentSection = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 15px;
  border: 2px solid rgba(255, 51, 51, 0.3);
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
  
  h2 {
    color: #ff3333;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1.8rem;
    
    &:first-of-type {
      margin-top: 0;
    }
  }
  
  p {
    line-height: 1.7;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  ul, ol {
    margin-bottom: 1.5rem;
    padding-left: 1.5rem;
    
    li {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }
  }
`;



const LegalNotice = () => {
  return (
    <>
      <PageHeader title="Legal Notice" highlightWord="Notice" />
      <LegalContainer>
        <ContentSection>
          <h2>Hosting Provider</h2>
          <p>Our services are hosted on secure infrastructure compliant with international data protection standards.</p>
          
          <h2>Platform Technology</h2>
          <p>This website is powered by Nextcloud, an open-source collaboration and file sharing platform. <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> operates independently and is not affiliated with Nextcloud GmbH.</p>
          
          <h2>Disclaimer</h2>
          <p>The content of this website is provided for general information purposes only. We make no warranties regarding accuracy, completeness, or reliability. External links do not imply endorsement.</p>
          
          <h2>Copyright</h2>
          <p>&copy; 2025 <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span>. All rights reserved.</p>
        </ContentSection>
      </LegalContainer>
    </>
  );
};

export default LegalNotice;
